import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.css'; //引入全局的base文件

// 按需引入部分组件
import {Swipe, SwipeItem,Image,List,Cell, CellGroup, Popup, Empty, Progress, Dialog } from 'vant';
import 'vant/lib/index.css';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Image);
Vue.use(List);
Vue.use(Cell).use(CellGroup);
Vue.use(Popup)
Vue.use(Empty)
Vue.use(Progress)
Vue.use(Dialog)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js